import { styled } from 'dripsy';
import React from 'react';
import { View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { observer } from 'mobx-react-lite';

import { BaseText } from '@components';
import { MusicNavigatorRoutePropType } from '@navigation';

const Container = styled(View)({
  flex: 1,
  bg: '$background0',
  px: ['$6', '5%'],
});

type NavigationRoutePropType = MusicNavigatorRoutePropType<'Track'>;

export const TrackScreen = observer(() => {
  const { params } = useRoute<NavigationRoutePropType>();

  return (
    <Container>
      <BaseText>{`Track id: ${params.id}`}</BaseText>
    </Container>
  );
});
